export default __webpack_public_path__ + "static/media/Cartão de Natal - Opção 03.1d68b27b.png";